import { HintsValidationComponent } from 'shared/hints/hints-validation/hints-validation.component';
import { LogsComponent } from 'shared/logs/logs.component';
import { CommentsComponent } from 'shared/comments/comments.component';
import { PRODUCT_GROUPS_NAME, MARKETING_NAME, CORE_NAME, PRICE_SHEETS_NAME } from '../brand-information/variables';
import { PROFILE_NAME, TEAM_NAME, PREFERENCES_NAME, BILLING_NAME, BRAND_NAME, TRADE_INFO_NAME } from '../account-information/variables';

export const rightPanelNavs: any[] = [
  {
    title: 'Hints',
    name: 'hints',
    active: true,
    component: HintsValidationComponent,
    disabledOn: [
      TEAM_NAME, BILLING_NAME
    ],
  },
  {
    title: 'Comments',
    name: 'comments',
    active: false,
    component: CommentsComponent,
    disabledOn: [
      PROFILE_NAME, TEAM_NAME, PREFERENCES_NAME, BILLING_NAME, BRAND_NAME, TRADE_INFO_NAME
    ],
  }
];
